<template>
  <section>
    <div class="container">
      <div class="row py-5 my-0 my-lg-5 align-items-center">
        <div class="col-12 col-md-6 fade-in-item right">
          <div class="me-0 d-flex align-items-center mb-5">
            <button
              :class="
                'btn me-2 shadow-sm ' +
                (floor == 0 ? 'btn-secondary' : 'btn-light')
              "
              @click="floor = 0"
            >
              First Floor
            </button>
            <button
              :class="
                'btn  shadow-sm ' + (floor == 1 ? 'btn-secondary' : 'btn-light')
              "
              @click="floor = 1"
            >
              Second Floor
            </button>
          </div>
          <div v-if="floor == 0">
            <div class="f-xmlg mb-4 bld">First Floor</div>
            <div class="f-lg l-op lh-lg">
              On the main floor, you will find a formal living room just off the
              entryway and a powder bath directly next door. Past the staircase
              is an open-concept great room, which includes a family room,
              semi-formal dining room, and roomy kitchen with center island.
            </div>
            <div class="row mt-4 f-lg mb-5 mb-md-0">
              <div class="col-6 lbld">Family Room</div>
              <div class="col-6">14' 7" x 16' 10"</div>
              <div class="col-6 lbld">Dining Room</div>
              <div class="col-6">11' 5" x 16' 10"</div>
              <div class="col-6 lbld">Kitchen</div>
              <div class="col-6">6' 9" x 18' 10"</div>
              <div class="col-6 lbld">Living Room</div>
              <div class="col-6">9' 10"x 13' 4"</div>
            </div>
          </div>
          <div v-if="floor == 1">
            <div class="f-xmlg mb-4 bld">Second Floor</div>
            <div class="f-lg l-op lh-lg">
              The second floor features a large master suite with large master
              bathroom and a massive walk-in closet, as well as two additional
              bedrooms, with an large open loft.
            </div>
            <div class="row mt-4 f-lg mb-5 mb-md-0">
              <div class="col-6 lbld">Owner's Suite</div>
              <div class="col-6">16' 2" x 19' 17"</div>
              <div class="col-6 lbld">Bedroom 2</div>
              <div class="col-6">13' 7" x 13' 13"</div>
              <div class="col-6 lbld">Bedroom 3</div>
              <div class="col-6">12' 5" x 11' 10"</div>
              <div class="col-6 lbld">Loft</div>
              <div class="col-6">12' 5" x 13' 4"</div>
            </div>
          </div>
        </div>
        <div
          class="col-12 col-md-6 fade-in-item left d-flex align-items-center justify-content-center"
        >
          <img
            v-if="floor == 0"
            src="https://cdn.pixilart.com/admin/files/27435caccf93a5e.png"
            class="img-l"
          />
          <img
            v-if="floor == 1"
            src="https://cdn.pixilart.com/admin/files/b5964401ff773bd.png"
            class="img-l"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      floor: 0,
    };
  },
};
</script>

<style>
.img-l {
  object-fit: contain;
  height: 100%;
  width: 100%;
  max-height: 700px;
}
</style>
